import { AxiosPromise } from 'axios';
import { ServicioProxy } from '../../../config/enums';
import { AxiosVue } from '../../../AxiosVue';

type DashboardResponse = {
  MENSAJE_RESPUESTA: string;
  CODIGO_RESPUESTA: string;
  [key: string]: any;
};

type RequestParams<T = any> = {
  serviceClient?: string;
  endpoint?: string;
  body?: { [key: string]: T };
};

const axios: AxiosVue = new AxiosVue(ServicioProxy.Metabase);

const makeHttpRequest = ({
  serviceClient = 'BajasCobranza',
  endpoint = 'get',
  body = {},
}: RequestParams): AxiosPromise<DashboardResponse> =>
  axios.http.post<DashboardResponse>(
    `Metabase/PostgenericA/${serviceClient}/${endpoint}`,
    body
  );

export const fetchMS = (
  params: RequestParams
): AxiosPromise<DashboardResponse> => makeHttpRequest(params);
